import * as types from '../constants/maildetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as maildetailsApi from '../api/maildetails';

export function resetMail() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MAIL_RESET });
    }
}

export function fetchMailDetails(id) {
    // console.log("fetchMailDetails action call");
    return dispatch => {        
        maildetailsApi.getMailDetails(id)
            .then(function (response) {
                // console.log("fetchMailDetails", response)
                dispatch({ type: types.FETCH_MAIL_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("fetchMailDetails Error", err)
                dispatch({ type: types.FETCH_MAIL_REQUEST_ERROR });
            });
    }
}

export function fetchMailDetailsList() {
    // console.log("fetchMailDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_MAIL_LIST_REQUEST });
        maildetailsApi.getMailList()
            .then(function (response) {
                // console.log("fetchMailDetailsList", response)
                dispatch({ type: types.FETCH_MAIL_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("fetchMailDetailsList Error", err)
                dispatch({ type: types.FETCH_MAIL_LIST_REQUEST_ERROR });
            });
    }
}

export function addMailDetails(objModel) {
    // console.log("addMailDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_MAIL_REQUEST });
        maildetailsApi.addMail(objModel)
            .then(function (response) {
                // console.log("addMailDetails action succ", response)
                if (response.status == 200) {
                    //dispatch({ type: types.ADD_MAIL_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                }
                dispatch({ type: types.ADD_MAIL_RESET });
            })
            .catch(function (err) {
                // console.log("addMailDetails action err", err)
                dispatch({ type: types.ADD_MAIL_REQUEST_ERROR });
            });
    }
}


// WEBPACK FOOTER //
// ./actions/maildetails.js